
  export class User {
    id: number;
    registrationDate: Date;
    isAdmin: boolean;
    email: string;
    firstName: string;
    lastName: string;
    role: number;
    groupId: number;
    venueId: number;
  }

  export class UserManagementModel {
    users: User[];
    totalCount: number;
    totalPages: number;
    page = 1;
    pageSize = 10;
  }






// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/user-management.model.ts